module.exports = __webpack_public_path__ + "static/media/traffic-yes.93fd5640.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/traffic-yes.svg
// module id = 827
// module chunks = 0